module.exports = __webpack_public_path__ + "static/img/reward-bg.6fc1d36e.png";